import { useCallback } from 'react';
import { RequestDeviceFormFields, requestDeviceFormClient } from '@bymason-private/controller-api';
import { useSaveDataHook } from '@bymason/api-hooks-base';

export { RequestDeviceFormFields, RequestDeviceOptions } from '@bymason-private/controller-api';

/**
 * React hook that asynchronously submits a request device form.
 * @returns HookArray
 * @HookArray [0] submitForm method
 * @HookArray [1] void
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 */
export function useSubmitRequestDeviceForm(clientToken: string) {
  const handleSubmitRequestDeviceForm = useCallback(
    (data: RequestDeviceFormFields) => {
      return requestDeviceFormClient.submit(data, clientToken);
    },
    [clientToken]
  );

  return useSaveDataHook(handleSubmitRequestDeviceForm);
}
